import React from 'react'
import { range } from 'libraries/lodash'
import cx from 'classnames'
import url from 'libraries/front-end-core/core/url'
import { MW_LIST_DEALS } from 'constants/controllers'
import { useSelector } from 'react-redux'
import selectAolName from 'redux/selectors/selectAolName'

const Footer = ({
  dealType,
  parameters,
  pageNumber,
  pageSize,
  resultStats,
  searchPhrase,
  total
}) => {
  const aol = useSelector(selectAolName)
  const pageCount = Math.ceil(total / pageSize)
  const lowerPageLimit = Math.max(1, pageNumber - 5)
  const upperPageLimit = Math.min(lowerPageLimit + 10, pageCount + 1)
  const before = []
  const after = []
  const linkCx = 'black db tc lh-pagination h2'

  const getPage = (page) => url(MW_LIST_DEALS, { aol, dealType }, {
    parameters,
    q: searchPhrase,
    page
  })

  if (pageSize < total) {
    if (pageNumber > 1) {
      before.push(
        <a
          key='first'
          className={cx(linkCx, 'mr4')}
          href={getPage(1)}
        >
          &laquo; First
        </a>,
        <a
          key='prev'
          className={cx(linkCx, 'mr4')}
          href={getPage(pageNumber - 1)}
        >
          <span>‹ Prev</span>
        </a>
      )
    }

    if (pageNumber < pageCount) {
      after.push(
        <a
          key='next'
          className={cx(linkCx, 'ml4')}
          href={getPage(pageNumber + 1)}
        >
          <span>Next ›</span>
        </a>,
        <a
          key='last'
          className={cx(linkCx, 'ml4')}
          href={getPage(pageCount)}
        >
          <div>
            <span>Last &raquo;</span>
          </div>
        </a>
      )
    }
  }

  return (
    <div>
      <div className='pa6 mt8'>
        <div className='flex flex-nowrap'>
          <div
            className='mb2'
          >
            {resultStats}
          </div>
        </div>
        <div className='flex items-center'>
          <div className='flex dn-m'>{before}</div>
          <div className='flex ba b--phantom-grey br--none br1'>
            {upperPageLimit > 2 &&
              range(lowerPageLimit, upperPageLimit, 1)
                .map(page => (page === pageNumber)
                  ? (
                    <a
                      className='f5 f6-m bg-black white tc lh-copy--spaced br b--phantom-grey w8 w7-m'
                      key={page}
                    >
                      {page}
                    </a>
                    )
                  : (
                    <a
                      className='f5 f6-m bg-transparent tc lh-copy--spaced br b--phantom-grey w8 w7-m no-underline black hover-black'
                      key={page}
                      href={getPage(page)}
                      data-testid='deal-list-page-number'
                    >
                      {page}
                    </a>
                    ))}
          </div>
          <div className='flex dn-m'>{after}</div>
        </div>
      </div>
    </div>
  )
}

export default Footer
